import dynamic from "next/dynamic";
import { banners } from "@features/landing/helpers/constants/spiral-banner";

const LandingBanner = dynamic(() => import("./banner"), { ssr: false });

const FestivalBanner: React.FC = () => {
  return (
    <section className="max-w-[1280px] mx-auto w-full px-4 sm:px-6">
      <div className="w-full flex flex-col sm:flex-row gap-6 justify-center items-center">
        {banners.map((banner, index) => (
          <LandingBanner key={index} {...banner} />
        ))}
      </div>
    </section>
  );
};

export default FestivalBanner;
